export enum RowClickModeDefiniton {
  Undefined = 0,
  Unclickable = 10,
  Clickable = 20,
}
